export default __webpack_public_path__ + "cf2a2fb8b6f67109d3abde9f08f59cc3.jpg";